/* @flow */

import type { BasicParamItem } from 'utils/uri';

export const concatParamKeyValues = (item: BasicParamItem) => {
  const _values = [...item.values].sort((a, b) => String(b).localeCompare(String(a)));
  return `${item.key}:${_values.join(',')}`;
};

export const serialiseParamArray = (items: BasicParamItem[]) => {
  return items
    .map(concatParamKeyValues)
    .sort((a, b) => b.localeCompare(a))
    .join(',');
};
